import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { empdetailsid11 } from "../../../Redux/Slice/TaskMasterSlice";
import { getAdvanceLeaves } from "../../../Redux/Slice/LeaveForm";
import { applyCorrection } from "../../../Redux/Slice/AttendanceCorrection";
import {
    FiDownload,
    FiUserCheck, FiChevronDown
} from "react-icons/fi";
import { format, subMonths, startOfMonth, endOfMonth, isBefore, addDays } from 'date-fns';
import Loader from "../../../Components/Loader/Loader";
import AttendanceDetailedBreakdown from "../../Payroll/AttendanceDetailedBreakdown";
import { toast } from "react-toastify";
import socket from '../../../socket';

const MyAttendance = () => {
    const dispatch = useDispatch();

    const loginData = Cookies.get("loginData");
    const parsedData = loginData ? JSON.parse(loginData) : null;
    const userId = parsedData?.data?._id;

    const { empdetailsid11Data, empdetailsid11Loading } = useSelector((state) => state.TaskMaster);
    const { leaveData, listLoading } = useSelector((state) => state.LeaveForm);
    const [selectedMonth, setSelectedMonth] = useState(format(new Date(), 'yyyy-MM'));
    const [breakdownData, setBreakdownData] = useState([]);
    const monthOptions = Array.from({ length: 12 })
        ?.map((_, i) => {
            const m = subMonths(new Date(), i);
            return {
                value: format(m, 'yyyy-MM'),
                label: format(m, 'MMMM yyyy')
            };
        })
        ?.filter(opt => opt.value >= '2026-02');

    useEffect(() => {

        socket.on("leaveUpdate", (data) => {
            console.log("Live leave update received (Attendance):", data);
            if (userId) {
                dispatch(getAdvanceLeaves(userId));
            }
        });

        return () => {
            socket.off("leaveUpdate");
        };
    }, [dispatch, userId]);


    useEffect(() => {
        if (userId) {
            dispatch(empdetailsid11({ id: userId }));
            dispatch(getAdvanceLeaves(userId));
        }
    }, [dispatch, userId]);



    // Generate All Dates for Selected Month
    const startOfMonthDate = startOfMonth(new Date(`${selectedMonth}-01T00:00:00`));
    const endOfMonthDate = endOfMonth(new Date(`${selectedMonth}-01T00:00:00`));
    const endOfTodayObj = new Date();

    // Only loop up to today if we are viewing the current month, otherwise show the full month
    const loopEnd = isBefore(endOfMonthDate, endOfTodayObj) ? endOfMonthDate : endOfTodayObj;

    const allDates = [];
    let current = startOfMonthDate;

    while (current <= loopEnd) {
        allDates.push(format(current, "yyyy-MM-dd"));
        current = addDays(current, 1);
    }





    const [isModalOpen, setIsModalOpen] = useState(false);
    const [correctionData, setCorrectionData] = useState({ date: format(new Date(), "yyyy-MM-dd"), reason: "" });

    if (empdetailsid11Loading || listLoading) {
        return (
            <>
                <Loader />
            </>
        );
    }

    const handleSubmitCorrection = (e) => {
        e.preventDefault();

        if (!userId) {
            toast.error("User ID not found. Please log in again.",
                {
                    position: "top-right",
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                }
            );
            return;
        }

        const payload = {
            userId: userId,
            correctionDate: correctionData.date,
            reason: correctionData.reason
        };

        dispatch(applyCorrection(payload)).then((res) => {
            if (res.payload.status === "Success") {
                toast.success(
                    "Correction request submitted successfully!",
                    {
                        position: "top-right",
                        autoClose: 1500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                    }
                );
                setIsModalOpen(false);
                setCorrectionData({ date: format(new Date(), "yyyy-MM-dd"), reason: "" });
            } else {
                toast.error("Failed to submit request: " + (res.payload.message || "Unknown error"),
                    {
                        position: "top-right",
                        autoClose: 1500,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                    }
                );
            }
        });
    };



    const formatTimeToHHMM = (isoString) => {
        if (!isoString) return "-";
        try {
            const date = new Date(isoString);
            if (isNaN(date.getTime())) return "-";

            let hours = date.getUTCHours();
            const minutes = String(date.getUTCMinutes()).padStart(2, "0");
            const ampm = hours >= 12 ? "PM" : "AM";
            hours = hours % 12;
            hours = hours ? hours : 12;
            return `${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
        } catch (error) {
            return "-";
        }
    };

    const formatDateLong = (dateStr) => {
        if (!dateStr) return "-";
        try {
            const d = new Date(dateStr);
            if (isNaN(d.getTime())) return "-";
            const day = String(d.getUTCDate()).padStart(2, "0");
            const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
            const month = months[d.getUTCMonth()];
            const year = d.getUTCFullYear();
            const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
            const dayOfWeek = days[d.getUTCDay()];
            return `${day} ${month} ${year} (${dayOfWeek})`;
        } catch (e) {
            return dateStr;
        }
    };

    const formatDurationText = (totalMinutes) => {
        if (totalMinutes <= 0) return "-";
        const hrs = Math.floor(totalMinutes / 60);
        const mins = totalMinutes % 60;
        return hrs > 0 ? `${hrs}h ${mins}m` : `${mins}m`;
    };

    const handleDownload = () => {
        if (!breakdownData || breakdownData.length === 0) return;

        const headers = ["Date & Day", "Punch In", "Punch Out", "Late Duration", "Early Exit Duration", "Status"];
        const csvContent = [
            headers.join(","),
            ...breakdownData.map(day => {
                const dateVal = formatDateLong(day.dateStr);
                const inVal = day.firstIn ? formatTimeToHHMM(day.firstIn) : "-";
                const outVal = day.lastOut ? formatTimeToHHMM(day.lastOut) : "-";
                const lateVal = day.lateMinutes > 0 ? formatDurationText(day.lateMinutes) : "-";
                const earlyVal = day.earlyMinutes > 0 && day.lastOut ? formatDurationText(day.earlyMinutes) : "-";

                let statusLabel = day.status;
                if (day.status === "Present") {
                    if (day.lateMinutes > 0 && day.earlyMinutes > 0 && day.lastOut) {
                        statusLabel = "Late & Early Exit";
                    } else if (day.lateMinutes > 0) {
                        statusLabel = "Late Arrival";
                    } else if (day.earlyMinutes > 0 && day.lastOut) {
                        statusLabel = "Early Exit";
                    } else {
                        statusLabel = "On Time";
                    }
                }

                return [
                    dateVal,
                    inVal,
                    outVal,
                    lateVal,
                    earlyVal,
                    statusLabel
                ].map(val => `"${val.replace(/"/g, '""')}"`).join(",");
            })
        ].join("\n");

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", `My_Attendance_${selectedMonth}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };



    return (
        <>
            <div className="px-3 py-6 min-h-0 font-sans bg-[#f8fafc]/50">
                <div className="w-full space-y-6">
                    {/* Page Title */}
                    <div className="title mb-4">
                        <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
                            My Attendance Logs
                        </h3>
                    </div>

                    {/* Header Action Row */}
                    <div className="bg-white p-4 rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-gray-100 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <div className="flex items-center gap-4">
                            <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center text-blue-600 shadow-sm border border-blue-100">
                                <FiUserCheck size={20} />
                            </div>
                            <div>
                                <h1 className="text-base font-bold text-gray-900 tracking-tight">Active Logs</h1>
                                <p className="text-gray-600 text-xs font-semibold uppercase tracking-wide">Personal tracking</p>
                            </div>
                        </div>
                        
                        <div className="flex flex-wrap items-center gap-3 w-full sm:w-auto justify-end">
                            <div className="relative">
                                <select
                                    value={selectedMonth}
                                    onChange={(e) => setSelectedMonth(e.target.value)}
                                    className="pl-4 pr-10 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold text-slate-700 outline-none appearance-none cursor-pointer focus:ring-4 focus:ring-blue-500/10 focus:border-blue-500/50 transition-all uppercase tracking-wider"
                                >
                                    {monthOptions.map((m) => (
                                        <option key={m.value} value={m.value}>{m.label}</option>
                                    ))}
                                </select>
                                <div className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none">
                                    <FiChevronDown className="w-4 h-4" />
                                </div>
                            </div>
                            <button
                                onClick={() => setIsModalOpen(true)}
                                className="flex items-center gap-2 px-5 py-2.5 bg-[#133A69] text-white rounded-xl text-xs font-bold hover:bg-slate-800 transition-all shadow-sm active:scale-95 cursor-pointer"
                            >
                                RAISE CORRECTION
                            </button>
                            <button
                                onClick={handleDownload}
                                className="flex items-center gap-2 px-5 py-2.5 bg-white border border-gray-200 rounded-xl text-xs font-bold text-gray-700 hover:bg-gray-50 transition-all shadow-sm active:scale-95 group cursor-pointer"
                            >
                                <FiDownload className="w-4 h-4 group-hover:-translate-y-0.5 transition-transform" />
                                DOWNLOAD RECORDS
                            </button>
                        </div>
                    </div>

                    <AttendanceDetailedBreakdown
                        filteredPunches={empdetailsid11Data?.isinout}
                        fromDate={format(startOfMonthDate, "yyyy-MM-dd")}
                        toDate={format(loopEnd, "yyyy-MM-dd")}
                        onDataProcessed={setBreakdownData}
                        checkInTime={parsedData?.data?.CheckInTime || "10:00"}
                        checkOutTime={parsedData?.data?.CheckOutTime || "19:00"}
                    />
                </div>
            </div>

            {/* Raise Correction Modal */}
            {isModalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    {/* Backdrop */}
                    <div
                        className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-300"
                        onClick={() => setIsModalOpen(false)}
                    ></div>

                    {/* Modal Content */}
                    <div className="bg-white w-full max-w-sm rounded-[32px] shadow-2xl relative z-10 overflow-hidden animate-in zoom-in-95 duration-300 border border-gray-100">
                        <button
                            onClick={() => setIsModalOpen(false)}
                            className="absolute right-6 top-6 text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-50 rounded-full"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>

                        <div className="p-5">
                            <h2 className="text-xl font-black text-gray-900 mb-2 tracking-tight">Raise Correction</h2>
                            <p className="text-slate-500 text-sm font-medium mb-8 leading-relaxed">
                                Specify the date and reason for the attendance discrepancy.
                            </p>

                            <form onSubmit={handleSubmitCorrection} className="space-y-6">
                                <div>
                                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-[0.15em] mb-2.5 block px-1">
                                        Date to Correct
                                    </label>
                                    <div className="relative group">
                                        <input
                                            type="date"
                                            required
                                            value={correctionData.date}
                                            onChange={(e) => setCorrectionData({ ...correctionData, date: e.target.value })}
                                            className="w-full bg-slate-50 border-2 border-gray-200 rounded-2xl px-5 py-4 text-sm font-bold text-slate-700 outline-none focus:border-blue-500 focus:bg-white transition-all appearance-none"
                                        />
                                        {/* <FiCalendar className="absolute right-5 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none group-focus-within:text-blue-500 transition-colors" /> */}
                                    </div>
                                </div>

                                <div>
                                    <label className="text-[10px] font-black text-slate-400 uppercase tracking-[0.15em] mb-2.5 block px-1">
                                        Reason / Issue
                                    </label>
                                    <textarea
                                        required
                                        rows="4"
                                        placeholder="E.g. Forgot to check in, marked absent while on WFH, etc."
                                        value={correctionData.reason}
                                        onChange={(e) => setCorrectionData({ ...correctionData, reason: e.target.value })}
                                        className="w-full bg-slate-50 border-2 border-gray-200 rounded-2xl px-5 py-4 text-sm font-bold text-slate-700 outline-none focus:border-blue-500 focus:bg-white transition-all resize-none placeholder:text-slate-300"
                                    ></textarea>
                                </div>

                                <div className="flex gap-4 pt-4">
                                    <button
                                        type="button"
                                        onClick={() => setIsModalOpen(false)}
                                        className="flex-1 py-4 bg-white border-2 border-slate-100 text-slate-600 font-extrabold text-sm rounded-2xl hover:bg-slate-50 active:scale-[0.98] transition-all"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="flex-2 px-8 py-4 bg-[#0f172a] text-white font-extrabold text-sm rounded-2xl hover:bg-slate-800 shadow-xl active:scale-[0.98] transition-all"
                                    >
                                        Submit Request
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default MyAttendance;